import React from 'react';
import {
  Table, Input, Button, Icon, Row, Col,
} from 'antd';
class ReportTableWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterTable: null,
      searchText: '',
      rowSelection: this.props.rowSelectionType ? { rowSelection: { type: 'radio', onChange: this.props.handlerowChange } } : undefined,
      onExpand: this.props.onExpand ? { onExpand: (expanded, record) => this.props.onExpand(record) } : undefined,
      expandable: this.props.expandedRowRender ? { expandedRowRender: record => this.props.expandedRowRender(record), rowExpandable: record => this.props.rowExpandable(record) } : undefined,
    };
    this.addFilter();
  }
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={`Search ${this.props.columns[0].title}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
            </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
            </Button>
      </div>
    ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  })
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  search = value => {
    const { data } = this.props;
    var filterTable = null;
    if (value.target.value.length > 1) {
      filterTable = data.filter(o =>
        Object.keys(o).some(k =>
          String(o[k])
            .toLowerCase()
            .includes(value.target.value.toLowerCase())
        )
      );
    } else {
      filterTable = data;
    }
    this.setState({ filterTable });
  };
  addFilter = (index = 0) => {
    this.props.columns[index] = {
      ...this.props.columns[index],
      ...this.getColumnSearchProps(this.props.column_search),
    };
  }
  renderTitleComponent = (title, buttons) => {
    return () => (<Row style={{ marginBottom: '20px' }}>
      <Row span={24}>
        <Col span={24}>
          {buttons ? buttons.map((button, index) => <Button key={index} type={button.buttonType} style={{ marginLeft: '10px' }} className="table-operation" onClick={button.clickHandler} disabled={button.disabled}><i className={button.iconType} /> {button.content}</Button>) : ""}
          {this.props.search === true ? <Input.Search
            style={{ width: '200px', float: 'right', paddingLeft: '10px', border: '1px solid rgba(78, 86, 148, 0.35)', backgroundColor: 'white', height: '40px', borderRadius: '5px', color: '#1b1a1e !important' }}
            placeholder="Search by..."
            onChange={this.search.bind(this)}
          /> : ""}
        </Col>
      </Row>
    </Row>)
  }
  render() {
    let { expandable, rowSelection, onExpand, filterTable, rowexpandable } = this.state
    return <Table rowKey={this.props.rowKey}
      {...onExpand}
      {...expandable}
      {...rowSelection}
      {...rowexpandable}
      bordered={true}
      size='small'
      loading={this.props.loading} columns={this.props.columns} dataSource={filterTable == null ? this.props.data : filterTable} title={this.renderTitleComponent(this.props.title, this.props.buttons)} />;
  }
}
export default ReportTableWrapper;